import React from "react";
import { useState, useEffect } from "react";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import { useRef } from "react";
import FormInputs from "../../../../components/UI/FormInputs";
import { isObject } from "../../../../utils/commonUtils";
import LeftRightInput from "../../Forms/LeftRight";
import NormalAbnormal from "../../Forms/NormalAbnormal";
import PositiveNegative from "../../Forms/PositiveNegative";
import ExamTableForm from "./ExamTableForm";
import RangeOfMotion from "../../Forms/RangeOfMotion";
import DropDown from "../../Forms/DropDown";
import Exercise from "../../Forms/Exercise";
import CustomMatrix from "../../Forms/CustomMatrix";

const EmrFormRender = ({
  fields,
  visit_id,
  employeeId,
  Toast,
  highlightTerm,
  expandedSection,
  setExpandedSection,
  setProgressApiTrigger,
  selectedSubTab,
  fetchProgressNotesByScreen,
  onFormUpdate,
  selectedTab
}) => {
  const [formState, setFormState] = useState({});
  const fieldRefs = useRef({});
  const sectionRefs = useRef({});
  const collapseRefs = useRef({});
  const [validation, setValidation] = useState({});
  const [normalSelectedId, setNormalSelectedId] = useState("");
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const newFormState = {};
    let shouldUpdate = false;
  
    fields.forEach((form) => {
      form.fields.forEach((field) => {
        if (!(field.id in formState)) {
          const prefill = field.prefillValue;
          if (prefill !== undefined) {
            if (field.field_type?.input_type === "MULTI_SELECT") {
              newFormState[field.id] = prefill ? prefill.split(",") : [];
            } else if (field.field_type?.input_type === "DROP_DOWN") {
              if (prefill.trim() === "") {
                newFormState[field.id] = ""
              } else {
                if (field.ismultiselect === 1) {
                  newFormState[field.id] = Array.isArray(prefill) ? prefill : JSON.parse(prefill);
                } else {
                    newFormState[field.id] = Array.isArray(prefill) ? prefill : JSON.parse(prefill);
                }
              }
            } else {
              newFormState[field.id] = prefill;
            }
            shouldUpdate = true;
          }
        }
      });
    });
  
    if (shouldUpdate) {
      setFormState((prev) => ({ ...prev, ...newFormState }));
    }
  }, [fields]);
  

  useEffect(() => {
    if (!highlightTerm) {
      setExpandedSection(null); // collapse accordion
      return;
    }
  
    const lowerTerm = highlightTerm.toLowerCase();
  
    let matchedFormId = null;
  
    fields.forEach((form) => {
      const match = form.fields.some((field) => {
        const labelMatch = field.label?.toLowerCase().includes(lowerTerm);
        const optMatch = (field.options || []).some((opt) =>
          opt.value?.toLowerCase().includes(lowerTerm)
        );
  
        if (labelMatch || optMatch) {
          matchedFormId = form.emr_form_id;
          return true;
        }
  
        return false;
      });
    });
  
    if (matchedFormId) {
      setExpandedSection(matchedFormId); 
    }
  }, [highlightTerm, fields]);

  const handleSubmit = async (form_id, item) => {
    console.log('handleSubmit',form_id ,item);
    
    try {
      const emr_field = [];

      item.fields.forEach((field) => {
        const fieldValue = formState[field.id];
        const inputType = field.field_type?.input_type;
      
        if (inputType === "MULTI_SELECT" && Array.isArray(fieldValue)) {
          emr_field.push({
            field_id: field.id,
            value: fieldValue.join(","),
          });
        } else if (["SINGLE_SELECT", "TEXT_FIELD", "TEXT_AREA", "DATE"].includes(inputType)) {
          emr_field.push({
            field_id: field.id,
            value: typeof fieldValue === "string" ? fieldValue : "",
          });
        }
        else{
          emr_field.push({
            field_id:field.id,
            value:formState[field.id],
          });
        }
      });

      const payload = {
        employee_id: employeeId,
        emr_field,
        screen_type: selectedSubTab,
      };

      const results = await EmrVisitsService.saveFields(
        null,
        visit_id,
        form_id,
        payload
      );

      setProgressApiTrigger((prev) => !prev);
  
      if (results?.status === 200 || results?.status === "SUCCESS") {
        setValidation({});
        Toast.success("Data has been added successfully.");
        if (typeof onFormUpdate === "function") {
          onFormUpdate(form_id);
        }
        return true;
      } else if (results.status === "ERROR") {
        const resultData = results.data;

        setValidation(() => {
          const newValidation = {};

          if (Array.isArray(resultData)) {
            resultData.forEach((itemWithErrorObject) => {
              if (isObject(itemWithErrorObject)) { 
                for (const key in itemWithErrorObject) {
                  if (Object.hasOwnProperty.call(itemWithErrorObject, key)) {
                    const message = itemWithErrorObject[key];
                    newValidation[key] = Array.isArray(message)
                      ? message.join(", ")
                      : message;
                  }
                }
              }
            });
          } else if (isObject(resultData)) {
            for (let key in resultData) {
              const message = resultData[key];
              newValidation[key] = Array.isArray(message)
                ? message.join(", ")
                : message;
            }
          } else {
            Toast.error(resultData || "Something went wrong.");
          }
        
          return newValidation;
        });
        return false; 
      }
    } catch (error) {
      console.error("Save failed:", error);
      Toast.error("Something went wrong while saving.");
      return false;
    }
  };
  
  

  const handleChange = (fieldId, value, isMulti, isSingle) => {
    setFormState((prev) => {
      if (isMulti) {
        const current = prev[fieldId] || [];
        const updated = current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value];
        return { ...prev, [fieldId]: updated };
      }

      if (isSingle) {
        return { ...prev, [fieldId]: value };
      }

      return { ...prev, [fieldId]: value };
    });


    setValidation((prevValidation) => {
      const newValidation = { ...prevValidation };
      delete newValidation[fieldId];
      return newValidation;
    });
  };
  return (
    <>
    <div className="col-9">
      <div className="sh_emrcardrow">
        <div className="sh_cardBox sh_emrfieldcardbox mb-1" style={{ height: "calc(100vh - 490px)" }}>
          <div className="sh_cardBody p-0">
            <div className="space-y-6">
              {
               
              (!fields || fields.length === 0 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "40vh" }}
                >
                  <div className="alert alert-info text-center m-0">
                    No Charts and Fields Available. Please Add Charts.
                  </div>
                </div>
              ) : (
                fields.map((item, idx) => {
                  const setSectionRef = (el) => {
                    if (el) sectionRefs.current[item.emr_form_id] = el;
                  };

                  
                  if (item.view_type === "TABLE") {
                    return (
                      <ExamTableForm
                        key={idx}
                        fields={fields}
                        sectionRefs={sectionRefs}
                        collapseRefs={collapseRefs}
                        fieldRefs={fieldRefs}
                        formState={formState}
                        setFormState={setFormState}
                        setValidation={setValidation}
                        validation={validation}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setSectionRef={setSectionRef}
                        item={item}
                        idx={idx}
                        selectedTab={selectedTab}
                      />
                    );
                  }
                  else{
                  return (
                    <div className="card m-2" key={idx} ref={setSectionRef}>
                      <a
                        href={`#accordion-${idx}`}
                        className="d-block card-header sh_accordionheader accordion-button collapsed"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls={`accordion-${idx}`}
                        onClick={() => setValidation({})}
                      >
                        <h6 className="m-0 text-md">{item.name}</h6>
                      </a>

                      <div
                        // className={`accordion-collapse collapse ${
                        //   expandedSection === item.emr_form_id ? "show" : ""
                        // }`}
                        className={`accordion-collapse collapse show`}
                        id={`accordion-${idx}`}
                        ref={(el) => {
                          if (el) collapseRefs.current[item.emr_form_id] = el;
                        }}
                        onTransitionEnd={(e) => {
                          // Clear validation only when the accordion is completely hidden
                          if (e.propertyName === 'height' && !e.target.classList.contains('show')) {
                              setValidation({});
                          }
                        }}
                      >
                        <div className="card-body py-2">
                          {item.fields.map((field, fIdx) => {
                            const fieldRef = (el) => {
                              if (el) {
                                fieldRefs.current[field.id] = el;
                              }
                            };
                            const { input_type, has_options } =
                              field.field_type || {};
                            const showOptions = has_options === 1;

                            return (
                              <div key={fIdx} className="row" ref={fieldRef}>
                                {/* Text Field */}
                                {/* {input_type === "TEXT_FIELD" &&
                                  !showOptions && (
                                    <div className="card w-100 mb-0">
                                      <div className="card-header sh_subaccordionheader">
                                        <h6 className="text-sm mb-0">
                                          {field.label}
                                        </h6>
                                      </div>
                                      <div className="card-body py-0">
                                        <div className="row">
                                          <div className="form-group col-12 mb-0">
                                            <TextArea
                                              className="w-100 sh_emrfieldtext"
                                              value={
                                                formState[field.id] || ""
                                              }
                                              changeHandler={(val) => {
                                                handleChange(field.id, val);
                                              }}
  
                                            />
                                            {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                   {input_type === "DATE" && !showOptions && (
                                    <div className="card w-100 mb-0">
                                      <div className="card-header sh_subaccordionheader">
                                        <h6 className="text-sm mb-0">{field.label}</h6>
                                      </div>
                                      <div className="card-body py-0">
                                        <div className="row">
                                          <div className="form-group col-12 mb-0">
                                            <FormInputs
                                              type="Date"
                                              name={`field-${field.id}`}
                                              className="form-control form-control-solid"
                                              value={formState[field.id] || ""}
                                              changeHandler={(val, { e }) => {
                                                const stringDate = typeof val === "string" ? val : String(val);
                                                handleChange(field.id, stringDate);
                                              }}
                                            />
                                            {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )} */}
                                {["TEXT_FIELD", "TEXT_AREA", "DATE", "DIGITAL_SIGNATURE"].includes(
                                  input_type
                                ) &&
                                  !showOptions && (
                                    <div className="card w-100 mb-0">
                                      <div className="card-header sh_subaccordionheader">
                                        <h6 className="text-sm mb-0">
                                          {field.label} 
                                          {field.is_required ? <span className="text-danger">*</span>:""}
                                        </h6>
                                      </div>
                                      <div className="card-body py-0">
                                        <div className="row">
                                          <div className={`form-group ${input_type === "DIGITAL_SIGNATURE" ? "col-4" : "col-12"} mb-0 my-1`}>
                                            <FormInputs
                                              type={
                                                input_type === "TEXT_AREA"
                                                  ? "TextArea"
                                                  : input_type === "DATE"
                                                  ? "Date"
                                                  : input_type === "DIGITAL_SIGNATURE"
                                                  ? "Signature"
                                                  : "TextInput"
                                              }
                                              name={`field-${field.id}`}
                                              className={
                                                input_type === "TEXT_AREA"
                                                  ? "w-100 m-1 sh_emrfieldtext form-control-solid"
                                                  : "form-control form-control-solid"
                                              }
                                              value={
                                                formState[field.id] || ""
                                              }
                                              // {...(input_type === "TEXT_AREA" ? { rows: 6 } : {})}
                                              rows={input_type==="TEXT_AREA"? 6:1}
                                              changeHandler={(val, options = {}) => {
                                                const { e } = options;
                                                const finalVal =
                                                  input_type === "DATE"
                                                    ? typeof val === "string"
                                                      ? val
                                                      : String(val)
                                                    : val;
                                                handleChange(
                                                  field.id,
                                                  finalVal
                                                );
                                              }}
                                            />
                                            {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {/* Multi / Checkbox Options */}
                                {["SINGLE_SELECT", "MULTI_SELECT"].includes(
                                  input_type
                                ) &&
                                  showOptions && (
                                    <div className="card w-100 mb-0">
                                      <div className="card-header sh_subaccordionheader">
                                        <h6 className="text-sm mb-0">
                                          {field.label}
                                          {field.is_required ? <span className="text-danger">*</span>:""}
                                        </h6>
                                      </div>
                                      <div className="card-body  py-2">
                                        <div className="row">
                                          {field.options.map(
                                            (opt, optIdx) => {
                                              const isSelected =
                                                input_type === "SINGLE_SELECT"
                                                  ? String(
                                                      formState[field.id]
                                                    ) === String(opt.id)
                                                  : (
                                                      formState[field.id] ||
                                                      []
                                                    )
                                                      .map(String)
                                                      .includes(
                                                        String(opt.id)
                                                      );

                                              return (
                                                <div
                                                  key={opt.id}
                                                  className="form-group sh_emrtableformgroup  col-6 mb-0"
                                                >
                                                  <div className="form-check">
                                                      <FormInputs
                                                        id={`opt-${field.id}-${opt.id}`}
                                                        type={
                                                          input_type ===
                                                          "SINGLE_SELECT"
                                                            ? "Radio"
                                                            : "Checkbox"
                                                        }
                                                        name={`field-${field.id}`}
                                                        className="form-check-input"
                                                        value={isSelected}
                                                        changeHandler={(
                                                          val,
                                                          { e }
                                                        ) => {
                                                          handleChange(
                                                            field.id,
                                                            opt.id,
                                                            input_type ===
                                                              "MULTI_SELECT",
                                                            input_type ===
                                                              "SINGLE_SELECT"
                                                          );
                                                        }}
                                                      />
                                                      </div>
                                                      <label
                                                        className="formlabel mb-0"
                                                        htmlFor={`opt-${field.id}-${opt.id}`}
                                                      >
                                                        {opt.value}
                                                      </label>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                        {validation[field.id] && (
                                          <span className="text-danger mt-1">
                                            {validation[field.id]}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {input_type=='LEFT_RIGHT_BILATERAL'?
                                  <>
                                  <LeftRightInput
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  />
                                  {validation[field.id] && (
                                    <div className="text-danger small mt-1">
                                      {validation[field.id]}
                                    </div>
                                  )}
                                  </>
                                  :
                                  ""
                                  }
                                  {input_type=='NORMAL_ABNORMAL'?
                                  <>
                                  <NormalAbnormal
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  />
                                  {validation[field.id] && (
                                    <div className="text-danger small mt-1">
                                      {validation[field.id]}
                                    </div>
                                  )}
                                  </>
                                  :
                                  ""
                                  }
                                  {input_type=='POSITIVE_NEGATIVE'?
                                  <>
                                    <PositiveNegative
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  />
                                  {validation[field.id] && (
                                    <div className="text-danger small mt-1">
                                      {validation[field.id]}
                                    </div>
                                  )}
                                  </>
                                  :
                                  ""
                                  }
                                  {input_type=='EXERCISE'?
                                  <>
                                  <Exercise
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  normalSelectedId={normalSelectedId}
                                  checked={checked}
                                  setNormalSelectedId={setNormalSelectedId}
                                  setChecked={setChecked}
                                  />
                                  {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                  </>
                                  :
                                  ""
                                  }
                                  {input_type=='RANGE_OF_MOTION'?
                                  <>
                                  <RangeOfMotion
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  normalSelectedId={normalSelectedId}
                                  checked={checked}
                                  setNormalSelectedId={setNormalSelectedId}
                                  setChecked={setChecked}
                                  />
                                  {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                  </>
                                  :
                                  ""
                                  }
                                    {input_type=='DROP_DOWN'?
                                  <>
                                  <DropDown
                                  field={field}
                                  setFormState={setFormState}
                                  handleChange={handleChange}
                                  formState={formState}
                                  value={formState[field.id]}
                                  normalSelectedId={normalSelectedId}
                                  checked={checked}
                                  setNormalSelectedId={setNormalSelectedId}
                                  setChecked={setChecked}
                                  />
                                  {validation[field.id] && (
                                              <div className="text-danger small mt-1">
                                                {validation[field.id]}
                                              </div>
                                            )}
                                  </>
                                  :
                                  ""
                                  }
                                   {input_type=='CUSTOM_MATRIX'?
                                  <>
                                    <CustomMatrix
                                  key={`${field.id}-${field.column_header || ''}`}
                                  field={field}
                                  setFormState={setFormState}
                                  formState={formState}
                                  value={formState[field.id]}
                                  />
                                  {validation[field.id] && (
                                    <div className="text-danger small mt-1">
                                      {validation[field.id]}
                                    </div>
                                  )}
                                  </>
                                  :
                                  ""
                                  }
                                  
                                                                    
                              </div>
                            );
                          })}
                        </div>
                        <div className="card-footer p-1 d-flex justify-content-center">
                          <button
                            className="btn btn-primary"
                            onClick={async () => {
                              const success = await handleSubmit(
                                item.emr_form_id,
                                item
                              );

                              if (success) {
                                setExpandedSection(null);
                                const el =
                                  collapseRefs.current[item.emr_form_id];
                                if (el && window.bootstrap?.Collapse) {
                                  const collapseInstance =
                                    window.bootstrap.Collapse.getOrCreateInstance(
                                      el
                                    );
                                  collapseInstance.hide(); // ✅ only collapse on success
                                }
                              }
                            }}
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                })
              ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  )
}

export default EmrFormRender
